import ReferralBanner from "../components/Banner/Banners/ReferralBanner";
import SiteBanner from "../components/Banner/Banners/SiteBanner";

export const DEFAULT_BANNER_LIST = Object.freeze([
  SiteBanner,
  ReferralBanner,
]);

export const REFERRAL_PAGE_BANNER_LIST = Object.freeze([
  ReferralBanner,
]);